import { render } from "./QuizQuestionFormBlock.vue?vue&type=template&id=60e296c1"
import script from "./QuizQuestionFormBlock.vue?vue&type=script&lang=js"
export * from "./QuizQuestionFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__